import type { UseQueryResult } from '@tanstack/react-query';
import type * as API from '@/api/interfaces';
import type { Theme } from '@/types/theme';
import { createNamedContext } from '@/utils/react';

export type AppThemingContextValue = {
  enabled: boolean;
  query: UseQueryResult<API.App.GetAppTheming.Response>;
  palette: Theme.WhiteLabelPalette;
  theme: API.App.GetAppTheming.Response;
};

export const AppThemingContext = createNamedContext<AppThemingContextValue>(undefined, 'AppTheming.Context');